module.exports = __webpack_public_path__ + "static/img/FLORENCE_OAK.6927b15.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/FLORENCE_OAK.jpg
// module id = dyWk
// module chunks = 0